export const urls = {
  GET_PONUDE_ZA_MASINU: 'DokPonude/vrati_dok_ponude_za_id_masine',
};
